<div class="item-editor-wrapper" id="special-wizard-item-editor" [ngClass]="{'primary-bg-color': breakPointService.isTabletDown$ | async}">
  <div class='header'>
    <button *ngIf="currentStep.canChangeItem"
            ftsAuditableButton
            class="btn btn-back btn-link btn-undecorated no-left-padding font-secondary text-uppercase"
            (click)="changeItem()">
      <fa-icon class="no-padding" [icon]="faAngleDoubleLeft"></fa-icon>
      {{'component.special_wizard_item_editor.back' | translate}}
    </button>

    <h2 class="h4 fw-500" *ngIf="(breakPointService.isXSMobile$ | async)">{{'component.special_wizard_item_editor.step' | translate}} {{currentStep.stepIndex + 1}}:</h2>

    <h3 class='h2 no-top-margin margin-right-20'>
      <span class="fw-600" *ngIf="currentStep.selectedOrderedItem.size !== 'Size'">{{currentStep.selectedOrderedItemSizeLabel}}&nbsp;</span>
      <span class="fw-600">{{currentStep.selectedOrderableItem.label}}<sup *ngIf="currentStep.selectedOrderableItem.labelSymbol">{{currentStep.selectedOrderableItem.labelSymbol}}</sup></span>
    </h3>
    <p [ngStyle]="{'margin-bottom': noticePeriod && hasCateringNoticeTime ? '0.5rem' : '1rem'}" class='fw-500 calories calories-display' *ngIf='calories'>{{calories}}</p>
    <span *ngIf="noticePeriod && hasCateringNoticeTime" class="selection-text-color prep-time">
      {{'component.item_editor.editor.prep_time' | translate}}{{formattedNoticePeriod}}
    </span>
    <p *ngIf="currentStep.selectedOrderableItem.description">{{currentStep.selectedOrderableItem.description}}</p>
  </div>

  <fts-item-choices
    [orderableItem]='currentStep.selectedOrderableItem'
    [wizardStepIndex]='currentStep.stepIndex'
    [isInModal]='true'
    [(item)]='currentStep.selectedOrderedItem'
    [hasGraphicalBuilder]='currentStep.selectedOrderableItem.useBuilder'
    [theme]="theme"
    (ingredientChange)='onIngredientChanged($event)'
  ></fts-item-choices>
</div>
